var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCheckmarkInline = function SvgIconCheckmarkInline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 8.012,
    viewBox: "0 0 11 8.012"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-checkmark-tiny-red",
    transform: "translate(-704.727 -447.153)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73",
    "data-name": "Group 73",
    transform: "translate(-28)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_183",
    "data-name": "Path 183",
    d: "M737.352 455.165a1 1 0 0 1-.676-.263l-3.625-3.322a1 1 0 1 1 1.351-1.475l2.879 2.639 4.7-5.258a1 1 0 0 1 1.491 1.334l-5.375 6.012a1 1 0 0 1-.7.332Z",
    fill: "currentColor"
  })))));
};
export { SvgIconCheckmarkInline as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMSIgaGVpZ2h0PSI4LjAxMiIgdmlld0JveD0iMCAwIDExIDguMDEyIj4KICAgIDxnIGlkPSJpY29uLWNoZWNrbWFyay10aW55LXJlZCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTcwNC43MjcgLTQ0Ny4xNTMpIj4KICAgICAgICA8ZyBpZD0iR3JvdXBfNzMiIGRhdGEtbmFtZT0iR3JvdXAgNzMiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0yOCkiPgogICAgICAgICAgICA8cGF0aCBpZD0iUGF0aF8xODMiIGRhdGEtbmFtZT0iUGF0aCAxODMiCiAgICAgICAgICAgICAgICAgIGQ9Ik03MzcuMzUyLDQ1NS4xNjVhMSwxLDAsMCwxLS42NzYtLjI2M2wtMy42MjUtMy4zMjJhMSwxLDAsMSwxLDEuMzUxLTEuNDc1bDIuODc5LDIuNjM5LDQuNy01LjI1OGExLDEsMCwwLDEsMS40OTEsMS4zMzRsLTUuMzc1LDYuMDEyYTEsMSwwLDAsMS0uNy4zMzJaIgogICAgICAgICAgICAgICAgICBmaWxsPSJjdXJyZW50Q29sb3IiLz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPgo=";